import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { softwareProformaIssueFormsDirectRoute } from '@atlassian/jira-router-routes-proforma-routes/src/softwareProformaIssueFormsDirectRoute.tsx';
import { softwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ProformaIssueFormsDirect, {
	LazyProformaIssueFormsDirect,
} from './ui/issue-forms-direct/index-old.tsx';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/issue-forms-direct/index.tsx';

export const softwareProformaIssueFormsDirectRouteEntry = createEntry(
	softwareProformaIssueFormsDirectRoute,
	() => ({
		group: 'software',
		layout: softwareProjectLayout,
		resources: [projectContextResource],
		// TODO: remove this when cleaning up migrate-proforma-issue-forms-to-entry-points fg
		component: ProformaIssueFormsDirect,
		entryPoint: () => {
			return fg('migrate-proforma-issue-forms-to-entry-points')
				? proformaIssueFormsDirectPageEntryPoint
				: undefined;
		},
		navigation: {
			menuId: MENU_ID.PROJECTS,
		},
		// TODO: remove this when cleaning up migrate-proforma-issue-forms-to-entry-points fg
		forPaint: [LazyProformaIssueFormsDirect],
		perfMetricKey: 'issue-forms-direct',
	}),
);
